(function () {
console.log("Hello!");

})();
//# sourceMappingURL=index.js.map
